export const sharedIcons = [];
